require("@/assets/sass/main.scss");

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueObserveVisibility from "vue-observe-visibility";
import ScrollAnimation from "./directives/scrollAnimation";
import InterSectionObserver from "./directives/intersectionObserver";
import "vuetify/dist/vuetify.min.css";

// Font awesome

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPhoneSquare,
  faDog,
  faPaw,
  faBone,
  faSyringe,
  faHospital,
  faClinicMedical,
  faCookieBite,
  faCut,
  faQuestionCircle,
	faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vuetify from './plugins/vuetify';

library.add(
  faFacebook,
  faInstagram,
  faPhoneSquare,
  faDog,
  faPaw,
  faBone,
  faSyringe,
  faHospital,
  faClinicMedical,
  faCookieBite,
  faCut,
  faQuestionCircle,
  faExclamationCircle
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueObserveVisibility);
Vue.directive('scrollanimation', ScrollAnimation);
Vue.directive('intersectionObserver', InterSectionObserver);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
